<template>
  <div id="app">
    <CommonHeader v-if="$route.path !== '/yourvoice'" :logo="homeData.head.logo" :path="homeData.head.register"></CommonHeader>
    <router-view :country_data="country_data" :country_loading="country_loading" />
    <CommonFooter v-if="$route.path !== '/yourvoice'" :screenWidth="screenWidth"></CommonFooter>
  </div>
</template>

<script>
import CommonHeader from "./components/CommonHeader.vue";
import CommonFooter from "./components/CommonFooter.vue";
import { getAreaCodeApi } from "@/api/register.js";
export default {
  data() {
    return {
      screenWidth: document.body.clientWidth,
      lgHomeData: {
        head: {
          register: "REGISTER",
          logo: require("./assets/imgs/widi-logo.png")
        }
      },
      xsHomeData: {
        head: {
          register: "REGISTER",
          logo: require("./assets/imgs/widi-logo-xs.png")
        }
      },
      country_data: JSON.parse(localStorage.getItem('country_data')),
      country_loading: false
    };
  },
  components: { CommonHeader, CommonFooter },
  computed: {
    homeData() {
      return this.screenWidth > 768 ? this.lgHomeData : this.xsHomeData;
    }
  },
  updated() {
    // 页面更新时重新给导航按钮赋值
    this.updateTit();
  },
  created() {
    this.setlang()
  },
  methods: {
    setlang(){
      if (window.localStorage.getItem('locale')){
        return
      } else {
        const systemLanguage = window.navigator.language || window.navigator.browserLanguage;
        if(["zh-CN", "zh", "zh-TW"].indexOf(systemLanguage) > -1){
          window.localStorage.setItem('locale', 'cn')
        } else {
          window.localStorage.setItem('locale', 'en')
        }
      }
    },
    // 获取国家
    getAreaCode() {
      const old_time = Date.parse(new Date(localStorage.getItem('country_data_time')))
      const new_time = Date.parse(new Date())
      const res = parseInt((new_time - old_time) / 1000 / 60)
      if (localStorage.getItem('country_data_time') && res < 55 && JSON.parse(localStorage.getItem('country_data'))) {
        return
      }
      this.country_loading = true
      getAreaCodeApi()
        .then(res => {
          this.country_data = res.data
          this.country_loading = false
          localStorage.setItem('country_data',JSON.stringify(res.data))
          localStorage.setItem('country_data_time',new Date())
        })
        .catch(error => {
          this.country_loading = false
          console.log(error);
        });
    },
    // 判断路由并给导航按钮重新赋值
    updateTit() {
      this.$nextTick(function() {
        this.xsHomeData.head.register = this.lgHomeData.head.register =
          this.$route.path === "/Home" ? "LOGIN" : "BACK TO HOMEPAGE"
      });
    },
    // 判断窗口大小
    resizeWindow() {
      // window.screenWidth = document.body.clientWidth;
      this.screenWidth = document.body.clientWidth
    }
  },
  mounted() {
    this.updateTit()
    this.getAreaCode()
    // 监听页面大小
    window.addEventListener("resize", () => this.resizeWindow())
  },
  destroyed() {
    // 销毁监听页面大小事件
    window.removeEventListener("resize", this.resizeWindow(), true)
  }
};
</script>
<style lang="scss"></style>
